import { render, staticRenderFns } from "./Spams.vue?vue&type=template&id=754c3b9a&"
import script from "./Spams.vue?vue&type=script&lang=js&"
export * from "./Spams.vue?vue&type=script&lang=js&"
import style0 from "./Spams.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports